import React, { createContext, useState, useEffect } from "react";
const StoreContext = createContext();

function StoreProvider(props) {
  const [state, setState] = useState(0);
  const [run, SetRun] = useState(false);
  const [menuBar, setMenuBar] = useState(false);
  const [sidebarContent, setSidebarContent] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [requestQuote, setRequestQuote] = useState({
    origincountry: "",
    OriginPort: "",
    OriginPortFullName: "",
    destinationCountry: "",
    destinationPort: "",
    destinationPortFullName: "",
    availvableDirection: "",
    availvableDirectionShort: "",
    dateShip: "",
    weekAhead: "",
    sealines: "",
    selectedDate: "",
  });
  const [dataQuote, setDataQuote] = useState({
    logo: "",
    compName: "",
    data: [],
  });
  const [shipmentNo, setShipmentNo] = useState("");
  const [transportmodeglobal, setTransportmodeglobal] = useState("SEA");
  const [shipmentStatus, setShipmentStatus] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [searchText, setsearchText] = useState("");
  const [searchAdmin, setSearchAdmin] = useState("");
  const [dashboardData, setDashboardData] = useState({
    loaded: false,
    data: {},
  });
  const [blogData, setBlogData] = useState({ loaded: false, data: "" });
  const [isUserLogin, setIsUserLogin] = useState(false);
  const [shipmentdetails, setShipmentdetails] = useState({});
  const [showMilestone, setShowMilestone] = useState(false);
  const [advSearchFilter, setAdvSearchFilter] = useState({
    value: "",
    tranportMode: "",
    etd: "",
    eta: "",
    ShipmentData: "",
  });
  const handleMenubar = (data = {}) => {
    setMenuBar(!menuBar);
  };
  const calculateAmmount = (ammount = 0) => {
    const amt = Number(parseFloat(ammount).toFixed(2)).toLocaleString("en", {
      minimumFractionDigits: 2,
    });
    return amt;
  };

  const [omsUserData, setOmsUserData] = React.useState({
    OrgPK: "",
    EmailId: "",
    FullName: "",
    Designation: "",
    Jobtitle: "",
    IsWebAccees: 0,
    IsActive: 0,
    OrgCodes: "",
    DirectRelatedOrgnisations: "",
    UserRoles: "",
    DefaultRole: "",
  });

  return (
    <StoreContext.Provider
      value={{
        state,
        isUserLogin,
        sidebarContent,
        shipmentNo,
        searchResult,
        requestQuote,
        dataQuote,
        menuBar,
        dashboardData,
        advSearchFilter,
        selectedIndex,
        shipmentStatus,
        blogData,
        shipmentdetails,
        showMilestone,
        transportmodeglobal,
        run,
        searchText,
        searchAdmin,
        omsUserData,
        setOmsUserData,
        setSearchAdmin,
        setsearchText,
        SetRun,
        setTransportmodeglobal,
        setShowMilestone,
        setShipmentdetails,
        setShipmentNo,
        setState,
        setIsUserLogin,
        setSidebarContent,
        setSearchResult,
        setRequestQuote,
        setDataQuote,
        setMenuBar,
        setDashboardData,
        handleMenubar,
        calculateAmmount,
        setAdvSearchFilter,
        setSelectedIndex,
        setShipmentStatus,
        setBlogData,
      }}
    >
      {props.children}
    </StoreContext.Provider>
  );
}

export { StoreProvider, StoreContext };
